import { Icons } from "@win-reality/react-ui";

import { LiveEventLockedAlert } from "../LiveEventLockedAlert/LiveEventLockedAlert";

function LiveEventLockedLineup() {
  return (
    <div>
      <LiveEventLockedAlert />

      <div className="flex flex-col items-center justify-center pt-24 gap-4 text-center">
        <Icons.Padlock className="size-12" />
        <div className="text-lg font-bold">Active Event</div>
        <p className="text-sm text-gray-600 max-w-xs">
          Event details cannot be changed after the event has started. The
          lineup is locked while the event is in progress.
        </p>
      </div>
    </div>
  );
}

export { LiveEventLockedLineup };
